import { useEnum } from "@/api/services/global/enum";
import { IconErrorOutline } from "@/assets/icons";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { InnerBox } from "@/components/elements/InnerBox";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { COMPANY_CONTRACT_STATUS, LABEL_DATE_CONTRACT_STATUS_MATCH } from "@/types/enum";
import { findLabelByValue } from "@/utils/object";
import { Grid, Typography, Box } from "@mui/material";
import { TGetCompanyDto } from "@/api/services/main/company/dtos/get-company.dto";
import { dayjs } from "@/utils/dayjs";
import { DATE_FORMAT } from "@/constants/datetime";

type TCompanyContractInfoProps = {
  data: Partial<TGetCompanyDto>;
};

export const CompanyContractInfo: FCC<TCompanyContractInfoProps> = ({ data }) => {
  const { data: contractStatusOptions } = useEnum("ECompanyContractStatus");

  const CONTRACT_STATUS_DATE_MAP: Record<string, typeof data.contractStartDate> = {
    [COMPANY_CONTRACT_STATUS.DURING_CONTRACT]: data.contractStartDate,
    [COMPANY_CONTRACT_STATUS.TRIAL]: data.trialStartDate,
    [COMPANY_CONTRACT_STATUS.CANCELED_CONTRACT]: data.contractEndDate,
    [COMPANY_CONTRACT_STATUS.TRIAL_CANCELLED]: data.trialEndDate,
  };

  const contractDate = data.contractStatus ? CONTRACT_STATUS_DATE_MAP[data.contractStatus] : null;
  const formattedContractDate = contractDate ? dayjs(contractDate).format(DATE_FORMAT) : null;

  return (
    <InnerBox title={<CompanyFormTitle text="契約情報" />} showDivider={false}>
      <Grid container spacing={3} sx={{ marginBottom: "16px" }}>
        <Grid item xs={6}>
          <ItemInfo
            label="契約ステータス"
            value={findLabelByValue(contractStatusOptions, data.contractStatus)}
          />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo
            label={
              data.contractStatus && data.contractStatus in LABEL_DATE_CONTRACT_STATUS_MATCH
                ? LABEL_DATE_CONTRACT_STATUS_MATCH[data.contractStatus as keyof typeof LABEL_DATE_CONTRACT_STATUS_MATCH]
                : "契約日"
            }
            value={formattedContractDate}
          />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo
            label="現在の外国人数"
            value={data.currentLearnerCount != null ? `${data.currentLearnerCount} 名` : null}
            isShowDivider={false}
          />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo
            label="有効アカウント数"
            value={data.activeAccountLearnerCount != null ? `${data.activeAccountLearnerCount} 件` : null}
            isShowDivider={false}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="cap12" color={black[70]}>
            <Box component="span" sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <IconErrorOutline fontSize="20px" color={black[80]} />
              irohana studyの契約に関するご要望は、別途お問い合わせください。
            </Box>
          </Typography>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
